import { useEffect, useState, useCallback } from "react";
import api from "../../lib/api";
import { Input } from "../../components/ui/input";
import { ITEM_STATUS, describeExpiry } from "./status";

export default function ExpiryOverview() {
  const [rows, setRows] = useState([]);
  const [cats, setCats] = useState([]);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");
  const [statusFilter, setStatusFilter] = useState("all");
  const [withinDays, setWithinDays] = useState("");
  const [clientFilter, setClientFilter] = useState("");

  const load = useCallback(() => {
    api.get("/training/expiry-overview").then((r) => setRows(r.data)).catch(() => {});
  }, []);
  useEffect(() => { load(); }, [load]);
  useEffect(() => {
    api.get("/training/categories").then((r) => setCats(r.data)).catch(() => {});
  }, []);

  const allClients = [...new Set(rows.flatMap((r) => r.clients || []))].sort();

  let view = rows.filter((r) => {
    if (q && !(r.person_name.toLowerCase().includes(q.toLowerCase()) || r.competency_name.toLowerCase().includes(q.toLowerCase()))) return false;
    if (cat && r.category !== cat) return false;
    if (clientFilter && !(r.clients || []).includes(clientFilter)) return false;
    if (statusFilter === "expired" && r.status !== "expired") return false;
    if (statusFilter === "expiring" && r.status !== "expiring") return false;
    if (withinDays) { const n = parseInt(withinDays, 10); if (r.days_remaining == null || r.days_remaining < 0 || r.days_remaining > n) return false; }
    return true;
  });

  return (
    <div className="flex flex-col gap-4" data-testid="expiry-overview-tab">
      <div className="flex flex-wrap items-center gap-2">
        <Input data-testid="expiry-search" placeholder="Find person or competency…" value={q} onChange={(e) => setQ(e.target.value)} className="h-9 w-56" />
        <select data-testid="expiry-cat" className="h-9 border-2 border-slate-300 rounded px-2 text-sm" value={cat} onChange={(e) => setCat(e.target.value)}>
          <option value="">All categories</option>{cats.map((c) => <option key={c.id} value={c.name}>{c.name}</option>)}
        </select>
        <select data-testid="expiry-status" className="h-9 border-2 border-slate-300 rounded px-2 text-sm" value={statusFilter} onChange={(e) => setStatusFilter(e.target.value)}>
          <option value="all">All statuses</option><option value="expired">Expired</option><option value="expiring">Expiring soon</option>
        </select>
        <select data-testid="expiry-within" className="h-9 border-2 border-slate-300 rounded px-2 text-sm" value={withinDays} onChange={(e) => setWithinDays(e.target.value)}>
          <option value="">Any time</option><option value="7">≤ 7 days</option><option value="14">≤ 14 days</option><option value="30">≤ 30 days</option><option value="60">≤ 60 days</option><option value="90">≤ 90 days</option>
        </select>
        <select data-testid="expiry-client" className="h-9 border-2 border-slate-300 rounded px-2 text-sm" value={clientFilter} onChange={(e) => setClientFilter(e.target.value)}>
          <option value="">All clients</option>{allClients.map((c) => <option key={c} value={c}>{c}</option>)}
        </select>
        <span className="text-xs text-slate-400">{view.length} record{view.length === 1 ? "" : "s"}</span>
      </div>

      <div className="bg-white border-2 border-slate-300 rounded-lg overflow-x-auto">
        <table className="w-full text-sm border-collapse">
          <thead><tr className="bg-slate-100 text-left text-xs uppercase text-slate-500">
            <th className="px-3 py-2">Person</th><th className="px-3 py-2">Competency</th><th className="px-3 py-2">Category</th>
            <th className="px-3 py-2">Expiry</th><th className="px-3 py-2">Days</th><th className="px-3 py-2">Status</th><th className="px-3 py-2">Client relevance</th>
          </tr></thead>
          <tbody>
            {view.map((r) => {
              const s = ITEM_STATUS[r.status] || ITEM_STATUS.missing;
              return (
                <tr key={r.competency_id} data-testid={`expiry-row-${r.competency_id}`} className="border-t border-slate-100">
                  <td className="px-3 py-2 font-semibold text-slate-800 whitespace-nowrap">{r.person_name}</td>
                  <td className="px-3 py-2">{r.competency_name}</td>
                  <td className="px-3 py-2 text-slate-500">{r.category || "—"}</td>
                  <td className="px-3 py-2 whitespace-nowrap">{describeExpiry(r)}</td>
                  <td className="px-3 py-2">{r.days_remaining != null ? r.days_remaining : "—"}</td>
                  <td className="px-3 py-2"><span className={`text-[10px] font-bold uppercase px-2 py-0.5 rounded border ${s.cls}`}>{s.label}</span></td>
                  <td className="px-3 py-2 text-xs text-slate-500">{(r.clients || []).join(", ") || "—"}</td>
                </tr>
              );
            })}
            {view.length === 0 && <tr><td colSpan={7} className="px-3 py-6 text-center text-slate-400">No matching records.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
